const AC_ENUMS_OPEN_FRM = 'acOpenFrm'
// const AC_ENUMS_OPEN_FRM_TWO = 'acOpenFrm2'

const ENUMS_COMPANY_TYPE = {
  1: '校泵站',
  2: '设备配件生产商',
  3: '经销商',
  5: '其他',
  6: '汽车电路维修'
}

const ENUMS_USER_STATUS = {
  UNAUTH: 0,
  AUTH: 1,
  VIP: 2
}

/**
 * 订单系列
 * SUBMITED(1, "已提交"),

 CANCELED(2, "已取消"),

 PAYED(3, "已支付"), // 如果是团购项目表示支付订金

 PAY_FAIL(4, "支付失败"),

 PAYED_ALL(5, "已付全款"), // 如果是团购项目表示已付全款

 CONSIGNMENT(6, "已经发货"),

 RECEIPT(7, "已经收货"),

 REFUND(8, "已退款");
 */
const ENUMS_ORDER_STATUS = {
  1: '待付款',
  2: '已取消',
  3: '已支付',
  4: '待付款',
  5: '已付全款',
  6: '已发货',
  7: '交易完成',
  8: '已取消'

}

const COLLECTION_MODULE_TYPE = {
  1: '已购课程',
  2: '资料大全',
  3: '故障代码',
  4: '部件信息',
  5: '垫片调整',
  6: '测试数据',
  7: '故障诊断',
  8: '电路资料',
  19: '万能搜搜'
}

const COLLECTION_MODULE = {
  COURSE: 1,
  RESOURCES: 2,
  FAULT: 3,
  PARTS: 4,
  GASKET: 5,
  TEST: 6,
  DIAGNOSIS: 7,
  PRESERVE: 8
}

const COLLECT_MODULE = {
  COMM_MSG_BOX_CONFIRM: {
    key: 'showMsgBoxConfirm',
    open: true
  },
  COMM_SEARCH_ITEM_DETAIL: {
    key: 'commSearchItemDetail',
    open: true
  },
  FAULT_CODE_LIST: {
    key: 'faultCodeList',
    open: true
  }
}

const COLLECT_MODULE_TYPE = {
  HOME: '首页',
  HOME_SEARCH: '首页搜索',
  FMS_CLICK: 'FMS点击',
  CAR_SEARCH: '修车搜索',
  WE_CHART_ORDER: '微信菜单',
  CARREPSEARCH: '首页查询',
  CARREP: '修车',
  SHOP: '商城',
  MY: '我的',
  QUICK_CLICK: '快捷分类点击',
  APP_OPEN: 'APP启动',
  FAULT_CODE: '故障代码',
  TEST_DATA: '测试数据',
  PARTS_INFO: '系统部件',
  SUP_INFO: '配套信息',
  GAS_ADJ: '垫片调整',
  PROTEL_DXP: '资料大全',
  SOSO: '万能搜搜',
  PROFEEDBACK: '帮助与反馈'
}

const COLLECT_OPTIONS_TYPE = {
  OPEN_APP: 'APP启动',
  LIST: '列表',
  DETAIL: '详情',
  LOGIN: '登录',
  LOGOUT: '退出',
  OPEN_PAGE: '打开页面',
  OPEN_DIV: '弹窗',
  CLICK: '点击',
  BACK_SEARCH: '后台搜索',
  DEFAULT: '默认'
}

export default {
  AC_ENUMS_OPEN_FRM,
  ENUMS_COMPANY_TYPE,
  ENUMS_ORDER_STATUS,
  ENUMS_USER_STATUS,
  COLLECTION_MODULE_TYPE,
  COLLECTION_MODULE,
  COLLECT_MODULE,
  COLLECT_MODULE_TYPE,
  COLLECT_OPTIONS_TYPE
}
